import React, { useRef } from 'react';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import { FiltroSopSales, RepositorioSopSales } from '../../core/repositories/sopSalesRepositorio';
import { formatarPorcentagem } from '../../core/utils/funcoes';
import { Line } from 'react-chartjs-2';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useToast } from '../../core/contexts/toast';
import { useTranslation } from 'react-i18next';


interface Props {
    filtro: FiltroSopSales;
    activeTab: string;
}
const SopSalesKpiChart: React.FC<Props> = (props) => {


    const { mostrarToast } = useToast();
    const { t } = useTranslation();

    const chartRef = useRef<Chart<'line'>>(null);
    const [data, setData] = React.useState<ChartData<'line'>>({} as ChartData<'line'>);
    const [carregando, setCarregando] = React.useState(true);

    React.useEffect(() => {
        //atualiza o tamanho do grafico quando o tab é alterado
      
        // if (chartRef.current) {
        //     chartRef.current.resize();
        //     alert("resize")
        // }
    }, [props.activeTab]);

    React.useEffect(() => {
        setCarregando(true);
        new RepositorioSopSales().getKpis(props.filtro).then((res) => {
            const labels: string[] = [];
            const forecast_accuracy: (number | null)[] = [];
            const yoy: (number | null)[] = [];

            res.forEach((item: any) => {
                labels.push(item.mes || "");
                forecast_accuracy.push(item.hasOwnProperty('forecast_accuracy') ? item.forecast_accuracy : null);
                yoy.push(item.hasOwnProperty('yoy') ? item.yoy : null);
            });

            setData({
                labels: labels,
                datasets: [
                    {
                        label: 'Forecast Accuracy',
                        data: forecast_accuracy,
                        borderColor: '#90CAF9',
                        backgroundColor: '#90CAF9',
                    },
                    {
                        label: 'YoY',
                        data: yoy,
                        borderColor: '#0089F8',
                        backgroundColor: '#0089F8',
                        yAxisID: 'y2',
                    },
                ],
            });
            setCarregando(false);
        }).catch((error) => {
            mostrarToast({
                titulo: t("pages.Erro!"),
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        })
    }, [props.filtro]);

    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    label: function (context: any) {
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${formatarPorcentagem(value / 100)}`;
                    },
                },
            },
            title: {
                display: false,
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {
            x: {
            },
            y: {
                title: {
                    display: true,
                    text: 'Forecast Accuracy',
                    // color: '#90CAF9',
                    // font: {
                    //     size: 14,
                    //     weight: 'bold',
                    // },
                },
                ticks: {
                    callback: (value: any) => formatarPorcentagem(value / 100)
                },
                beginAtZero: false,
            },
            y2: {
                title: {
                    display: true,
                    text: 'YoY',
                    // color: '#0089F8',
                    // font: {
                    //     size: 14,
                    //     weight: 'bold',
                    // },
                },
                type: 'linear',
                position: 'right',
                beginAtZero: false,
                //formatar porcentagem
                ticks: {
                    callback: (value: any) => formatarPorcentagem(value / 100),
                },

                grid: {
                    drawOnChartArea: false,
                },

            },
        },
    }


    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className="title-card">KPI</strong>
            {carregando ?
                <SopLoadingAnimation type="LINE" />
                :
                <Line ref={chartRef} options={options} data={data} />
            }
        </div>
    );
};

export default SopSalesKpiChart;
